import Avatar from 'components/Avatar';
import { UserCard } from 'components/Card';
import React from 'react';
import Authentication from './../../core/frameworks/Authentication';
import {
  MdClearAll,
  MdExitToApp,
  //MdHelp,
  MdSettingsApplications,
} from 'react-icons/md';
import {
  Button,
  ListGroup,
  ListGroupItem,
  // NavbarToggler,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from 'reactstrap';
import bn from 'utils/bemnames';

import { Link } from 'react-router-dom';




const bem = bn.create('header');


class Header extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpenUserCardPopover: false,
      tipoUsuario:{}

    }

    
  }


  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };
  logout = async () => {

    const Auth = new Authentication();
    
    try {
      await Auth.signOut();
      this.props.history.push('/');
    } catch(error) {
      console.log(error);
    }
  };






  render() {

    const {user} = this.props;

    const nombresUsuario = user.nombres!==undefined?user.nombres:''; 
    const apellidosUsuario = user.apellidos!==undefined?user.apellidos:''; 
    const nombreCompleto = nombresUsuario+' '+apellidosUsuario;

    return (
      <Navbar light expand className={bem.b('bg-white')}>
        <Nav navbar className="mr-2">
          <Button outline onClick={this.handleSidebarControlButton}>
            <MdClearAll size={25} />
          </Button>
        </Nav>


        <Nav navbar className={bem.e('nav-right')}>


          <NavItem>
            <NavLink id="Popover2">
              <Avatar
                onClick={this.toggleUserCardPopover}
                className="can-click"
              />
            </NavLink>
            <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover}
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 250, boxShadow: '0px 3px 9px rgba(0,0,0,0.1)' }}
            >
              <PopoverBody className="p-0 border-light">
                <UserCard
                  title={nombreCompleto}
                  subtitle={user.email!==undefined?user.email:''}
                  text={user.permisos!==undefined?user.permisos.nombre:''}
                  className="border-light"
                >
                  <ListGroup flush>
                    <Link to="/configuracionUsuario" className="nolink">
                      <ListGroupItem tag="button" action className="border-light">
                        <MdSettingsApplications /> Configuración usuario
                      </ListGroupItem>
                    </Link>
                    {/* <ListGroupItem tag="button" action className="border-light">
                      <MdHelp /> Ayuda
                    </ListGroupItem> */}
                    <ListGroupItem tag="button" action  onClick={ this.logout } className="border-light">
                      <MdExitToApp /> Salir
                    </ListGroupItem>
                  </ListGroup>
                </UserCard>
              </PopoverBody>
            </Popover>
          </NavItem>
{/*           <ListGroupItem tag="button" action onClick={ this.logout } className="border-light btn-navbar">
            <MdExitToApp /> Salir
          </ListGroupItem> */}
        </Nav>
      </Navbar>
    );
  }
}

export default Header;
